<template>
  <div>
    <!-- HERO -->
    <section class="hero">
      <div class="hero__overlay"></div>
      <header class="header">
        <AppLogo asLink to="/" size="md" :showText="true" />
      </header>
    </section>

    <!-- 메인 카드 -->
    <main class="main">
      <div class="container">
        <div class="card forgot-card">
          <div class="forgot-inner">
            <div class="forgot-head">
              <div class="forgot-badge">비밀번호 재설정</div>
              <h1 class="forgot-title">Reset Password</h1>
            </div>

            <p class="description">
              가입하신 휴대폰 번호를 입력해주세요.<br />
              비밀번호 재설정 링크를 문자로 보내드립니다.
            </p>

            <form class="forgot-form" @submit.prevent="handleSubmit">
              <UiInput
                v-model="phoneNumber"
                type="tel"
                inputmode="tel"
                placeholder="휴대폰 번호 ( - 제외)"
                autocomplete="tel"
              />

              <UiButton
                type="submit"
                :disabled="!isPhoneValid || loading"
                :loading="loading"
              >
                다음
              </UiButton>
            </form>
          </div>
        </div>
      </div>
    </main>

    <!-- 푸터 -->
    <footer class="footer" style="margin-top: var(--space-64)">
      <div class="footer-bar">
        <span class="hint">Copyright ⓒ 2025 Cardio Factory</span>
      </div>
    </footer>
  </div>
</template>

<script>
import UiButton from "@/components/UiButton.vue";
import UiInput from "@/components/UiInput.vue";
import AppLogo from "@/components/AppLogo.vue";
import { api } from "@/lib/api";

export default {
  name: "ForgotPasswordView",
  components: { UiButton, UiInput, AppLogo },
  data() {
    return {
      phoneNumber: "",
      loading: false,
    };
  },
  computed: {
    isPhoneValid() {
      const digits = (this.phoneNumber || "").replace(/\D/g, "");
      return digits.length >= 10 && digits.length <= 11;
    },
  },
  methods: {
    async handleSubmit() {
      if (!this.isPhoneValid || this.loading) return;
      this.loading = true;

      try {
        const res = await api("/v1/auth/forgot-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone_number: this.phoneNumber.replace(/\D/g, ""),
          }),
        });

        if (!res.ok) throw new Error("비밀번호 재설정 요청 실패");

        alert(
          "비밀번호 재설정 링크를 문자로 발송했습니다.\n문자를 확인해주세요."
        );

        this.$router.push("/signin");
      } catch (e) {
        console.error(e);
        // 에러는 이미 handleApiError에서 처리되므로 여기서는 추가 처리하지 않음
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.hero {
  height: 220px;
  position: relative;
}

/* 카드 */
.forgot-card {
  max-width: 758px;
  margin: 0 auto;
  padding: 48px 56px;
  background: #151718;
  border-radius: 30px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
}

/* 내부 360px 컨테이너 */
.forgot-inner {
  max-width: 360px;
  margin: 0 auto;
}

/* 제목 */
.forgot-head {
  margin-bottom: 24px;
  text-align: left;
}

.forgot-badge {
  color: #78ff47;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: -0.01em;
}

.forgot-title {
  margin: 6px 0 0;
  font-weight: 700;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: -2px;
  text-align: left;
}

/* 설명 */
.description {
  margin: 0 0 24px;
  font-family: "Pretendard", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: -0.02em;
  color: #8e8e8e;
  text-align: left;
}

/* 폼 */
.forgot-form {
  display: grid;
  gap: 16px;
  width: 100%;
}

.forgot-form :deep(.ui-input) {
  height: 54px;
  border-radius: 5px;
  border: 1px solid #fff !important;
  background: #151718;
  color: #fff;
  padding: 0 14px;
}

.forgot-form :deep(.ui-input::placeholder) {
  color: rgba(255, 255, 255, 0.6);
}

.forgot-form :deep(.ui-input:focus) {
  outline: none;
  border-color: #fff !important;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25);
}

.forgot-form .ui-btn {
  width: 100%;
}

/* 풀-블리드 푸터 바 */
.footer-bar {
  width: 100%;
  margin: 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  background: #151718;
}

.hint {
  color: #8e8e8e;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 640px) {
  .forgot-card {
    padding: 28px 20px;
    border-radius: 20px;
    width: 100%;
  }

  .forgot-title {
    font-size: 32px;
  }

  .description {
    font-size: 14px;
  }
}
</style>
